import { useAppDispatch } from '../../../shared/lib/hooks/useAppDispatch/useAppDispatch'
import { useAppSelector } from '../../../shared/lib/hooks/useAppSelector/useAppSelector'
import { modalActions, selectModalData } from '../../../entities/Modal'
import { ChangeStateModal } from '../../../shared/ui/ChangeStateModal/ChangeStateModal'
import { deleteClient } from '../model/services/deleteClient'
import { RoutePath } from '../../../shared/config/routeConfig/routeConfig'
import { useNavigate } from 'react-router-dom'

export const DeleteClientModal = () => {

	const dispatch = useAppDispatch()
	const navigate = useNavigate()
	const data = useAppSelector(selectModalData)

	const header = (
		<>
			Please confirm that you want to delete the client
		</>
	)

	const handleConfirm = async () => {
		const result = await dispatch(deleteClient(data.clientId))
		if (result.meta.requestStatus === 'fulfilled') {
			navigate(RoutePath.clients)
			dispatch(modalActions.hideModal())
		}
	}

	return (
		<ChangeStateModal
			handleConfirm={handleConfirm}
			headerMsg={header}
		/>
	)
}